// extracted by css-extract-rspack-plugin
export default {"root":"root-lUIozC","content":"content-LhNOY_"};